<template>
    <svg :width="width" :height="height" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.8067 4.69305C14.0667 4.43305 14.0667 3.99971 13.8067 3.75305L12.2467 2.19305C12 1.93305 11.5667 1.93305 11.3067 2.19305L10.08 3.41305L12.58 5.91305L13.8067 4.69305ZM2 11.4997V13.9997H4.5L11.8733 6.61971L9.37333 4.11971L2 11.4997Z"
        />
    </svg>
</template>
<script>
export default {
    name: 'IconEdit',
    props: {
        width: {
            type: Number,
            default: 18,
        },
        height: {
            type: Number,
            default: 18,
        },
    },
}
</script>
